import CustomChallengeCreator from './CustomChallengeCreator';

export default CustomChallengeCreator;
